import http from '~/common/http';
import CustomerService from "~/services/customer";
export default {
    // 成交订单分析统计
    getList(params, action) {
        return http.get('/api/customer-std/' + action, {
            params: params
        });
    },

    create(params) {
        return http.post("/api/customer-std/create", params);
    },

    createCorp(params) {
        return http.post("/api/customer-std/create-corp", params);
    },

    update(params) {
        return http.put("/api/customer-std/update", params);
    },

    updateCorp(params) {
        return http.put("/api/customer-std/update-corp", params);
    },

    delete(params) {
        return http.delete('api/customer-std/delete',{
            data: params
        })
    },

    deleteCorp(params) {
        return http.delete('api/customer-std/delete-corp',{
            data: params
        })
    },
    
    revert(params) {
        return http.post("/api/customer-std/revert", params);
    },

    unbindCorp(params) {
        return http.post("/api/customer-std/unbind-corp", params);
    },

    bindCorp(params) {
        return http.post("/api/customer-std/bind-corp", params);
    },

    //得到客户筛选项配置
    getFields(path, active_name) {
        // console.log('std-getFields: ', path, active_name);
        const types = CustomerService.getTypes(true);
        return [
            {field: 'base', label: '基础信息筛选条件', children: [
                {field: 'name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
                {field: 'matching_name', label: '精准客户名称', type: 'input'},
                {field: 'id', label: '客户ID', type: 'input'},
                {field: 'type', label: '客户类型', type: 'select', list: Object.keys(types).map(key => ({ value: key, label: types[key] }))},
                {field: 'tag_ids', label: '名校标签', type: 'components', ref: 'tag', components: 'TagSelect', change: 'getValue'},
                {field: 'auth_site_ids', label: '授权站点', type: 'components', ref: 'auth', components: 'AuthSite', change: 'getValue'},
                {field: 'school_type', label: '办学性质', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '民办'}, {value: 2, label: '公办'}]},
                {field: 'short_name', label: '客户简称', type: 'input'},
                {field: 'username', label: '业务员', type: 'components', ref: 'user', components: 'UserSelect', change: 'changeObjValue'},
                {field: 'corp_ids', label: '归属集团', type: 'components', ref: 'corp', components: 'CorpSelect', change: 'getValue'}
            ]},
            {field: 'date', label: '时间筛选条件', children: [
                {field: 'created_at', label: '创建时间', type: 'daterange'},
            ]},
            {field: 'other', label: '其他筛选条件', children: [
                {field: 'stages', label: '开设学段', type: 'select', list: [{value: 'is_grade_school', label: '小学'}, {value: 'is_middle_school', label: '初中'}, {value: 'is_high_school', label: '高中'}, {value: 'is_vsh_school', label: '职中'}], multiple: true, clearable: true},
                {field: 'bind_resource', label: '是否绑定资源', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '是'}, {value: 2, label: '否'}]},
                {field: 'open_product', label: '是否开通产品', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '是'}, {value: 2, label: '否'}]},
            ]},
        ];
    },
}


// WEBPACK FOOTER //
// ./src/services/CustomerStd.js